import React from 'react';
import DataGridList from "../../components/CommonList/DataGridList.js";

const DashboardAdmin = () => {

  const columns = [
    { name: 'First Name', index: 'first_name', type: 'text' },
    { name: 'Last Name', index: 'last_name', type: 'text' },
    { name: 'Email', index: 'email', type: 'text' },
    { name: 'Enabled', index: 'is_active', type: 'input-switch' },
  ];

  const options = {
    crud: true,
    add: {
      route: "/admin/resonicadmin/form"
    },
    edit: {
      route: "/admin/resonicadmin/form"
    },
    details: {
      route: "/admin/resonicadmin/details"
    },
    delete: {
      route: "resonicadmin/"
    },
    enabledOpt: {
      url_edit: 'resonicadmin/',
      field: 'is_active'
    },
    export: {
      route: ""
    },
  }

  const url = "resonicadmins"

  const filters = [
    // { name: "Date From", index: 'modified_after', type: 'date'},
    // { name: "Date To", index: 'modified_before', type: 'date'},
    // { name: "Search", index: 'search', type: 'text'},
  ];

  // // Restablece los filtros en el almacenamiento local
  // window.localStorage.removeItem('filters');
  // localStorage.removeItem('currentPage');

  return (
      <DataGridList url={url} columns={columns} options={options} filters={filters}/>
  );
};

export default DashboardAdmin;
